import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaAd,
  FaVideo,
  FaGavel,
  FaMicrophone,
  FaBullhorn,
  FaMoneyBillWave,
  FaCreditCard,
  FaTimes,
} from "react-icons/fa";

// create  API That get get from the backend  this api we use here for the stats count for cards ,create a proper api
const fetchReporterDashboardStats = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/reporter/dashboard/stats`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reporter dashboard stats:", error);
    throw error;
  }
};

const ReporterDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [advertisementCount, setAdvertisementCount] = useState(0);
  const [voiceCount, setVoiceCount] = useState(0);
  const [conferenceCount, setConferenceCount] = useState(0);
  const [completedConferenceCount, setCompletedConferenceCount] = useState(0);
  const [paidConferenceCount, setPaidConferenceCount] = useState(0);
  const [rewardAdsCount, setRewardAdsCount] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await fetchReporterDashboardStats();
        setStats(data);
      } catch (error) {
        setStats({});
      }
    };

    const fetchAdvertisementCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/new/ads`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setAdvertisementCount(Array.isArray(response.data) ? response.data.length : (response.data?.data?.length || 0));
      } catch (error) { setAdvertisementCount(0); }
    };

    const fetchVoiceCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/new/voice`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setVoiceCount(Array.isArray(response.data) ? response.data.length : (response.data?.data?.length || 0));
      } catch (error) { setVoiceCount(0); }
    };

    const fetchConferenceCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/new/conferences`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setConferenceCount(Array.isArray(response.data) ? response.data.length : (response.data?.data?.length || 0));
      } catch (error) { setConferenceCount(0); }
    };

    const fetchCompletedConferenceCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/completed/conferences`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setCompletedConferenceCount(Array.isArray(response.data) ? response.data.length : (response.data?.data?.length || 0));
      } catch (error) { setCompletedConferenceCount(0); }
    };

    const fetchPaidConferenceCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/new/paid-conferences`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setPaidConferenceCount(Array.isArray(response.data) ? response.data.length : (response.data?.data?.length || 0));
      } catch (error) { setPaidConferenceCount(0); }
    };

    const fetchRewardAdsCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reporter/get/free/ad/stats`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (response.data && response.data.success && response.data.data) {
          setRewardAdsCount(response.data.data.available || 0);
        }
      } catch (error) { setRewardAdsCount(0); }
    };

    fetchStats();
    fetchAdvertisementCount();
    fetchVoiceCount();
    fetchConferenceCount();
    fetchCompletedConferenceCount();
    fetchPaidConferenceCount();
    fetchRewardAdsCount();
  }, []);

  const dashboardCards = [
    {
      title: "Advertisement",
      icon: <FaAd />,
      path: "/reporter/advertisement",
      color: "from-blue-600 to-indigo-700",
      shadow: "shadow-blue-100",
      count: advertisementCount,
    },
    {
      title: "Reward Ads",
      icon: <FaAd />,
      path: "/reporter/freeads",
      color: "from-purple-600 to-indigo-800",
      shadow: "shadow-purple-100",
      count: rewardAdsCount,
      label: "Mandatory"
    },
    {
      title: "Free Press",
      icon: <FaVideo />,
      path: "/reporter/freeconference",
      color: "from-emerald-500 to-teal-700",
      shadow: "shadow-emerald-100",
      count: completedConferenceCount,
      label: "Done"
    },
    {
      title: "Paid Press",
      icon: <FaCreditCard />,
      path: "/reporter/paidconference",
      color: "from-amber-500 to-orange-700",
      shadow: "shadow-amber-100",
      count: paidConferenceCount,
      label: "New"
    },

    {
      title: "Public Voice",
      icon: <FaBullhorn />,
      path: "/reporter/raisevoice",
      color: "from-sky-500 to-blue-800",
      shadow: "shadow-sky-100",
      count: voiceCount,
    },
    {
      title: "Financials",
      icon: <FaMoneyBillWave />,
      path: "/reporter/wallet",
      color: "from-slate-700 to-slate-900",
      shadow: "shadow-slate-100",
      count: stats.paymentCount || 0,
    },
  ];

  return (
    <div className="bg-[#F8FAFC] min-h-screen pb-10">
      {/* Sleek Premium Header */}
      <div className="bg-white border-b border-slate-100 px-4 py-6 sm:px-8 sm:py-8 mb-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Operational Status: Live</span>
            </div>
            <h1 className="text-2xl font-[1000] text-slate-900 tracking-tight">Reporter <span className="text-indigo-600">Central.</span></h1>
          </div>
          <div className="hidden sm:flex items-center gap-3">
            <div className="bg-slate-50 p-2 rounded-2xl border border-slate-100">
              <FaBullhorn className="text-indigo-600 text-xl" />
            </div>
          </div>
        </div>
      </div>

      <div className="px-3 sm:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6">
          {dashboardCards.map((card, index) => (
            <button
              key={index}
              onClick={() => navigate(card.path)}
              className={`
                relative overflow-hidden group p-4 sm:p-6 rounded-[2rem] bg-gradient-to-br ${card.color}
                ${card.shadow} shadow-2xl transition-all duration-300 hover:scale-[1.02] active:scale-95 text-left
              `}
            >
              {/* Decorative Glow */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-white/10 rounded-full -mr-12 -mt-12 blur-2xl group-hover:scale-150 transition-transform duration-700" />

              {/* Card Meta */}
              <div className="flex justify-between items-start mb-4">
                <div className="p-2.5 bg-white/20 backdrop-blur-md rounded-2xl border border-white/20 shadow-lg text-white text-xl sm:text-2xl">
                  {card.icon}
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-2xl sm:text-3xl font-[1000] text-white tracking-tighter leading-none">
                    {card.count}
                  </span>
                  {card.label && (
                    <span className="text-[9px] font-black uppercase text-white/70 tracking-widest mt-1 bg-white/10 px-1.5 rounded-full border border-white/5">
                      {card.label}
                    </span>
                  )}
                </div>
              </div>

              {/* Title & Action */}
              <div className="space-y-1">
                <h2 className="text-white font-black text-sm sm:text-base tracking-tight">{card.title}</h2>
                <div className="flex items-center gap-1 group-hover:gap-2 transition-all duration-300">
                  <span className="text-[10px] font-bold text-white/60 uppercase tracking-widest">Access Control</span>
                  <div className="w-1.5 h-1.5 rounded-full bg-white/40 group-hover:bg-white transition-colors" />
                </div>
              </div>
            </button>
          ))}

          {/* Special ID Card Access - Dynamic UI */}
          <button
            onClick={() => navigate('/reporter/getidcard')}
            className="col-span-2 sm:col-span-1 p-4 sm:p-6 rounded-[2rem] bg-white border border-slate-100 shadow-xl shadow-slate-200/50 flex flex-col justify-between group hover:border-slate-300 transition-all active:scale-95 text-left"
          >
            <div className="flex justify-between items-center mb-6">
              <div className="w-12 h-12 bg-slate-900 rounded-2xl flex items-center justify-center text-white text-xl">
                <FaCreditCard />
              </div>
              <div className="px-3 py-1 bg-slate-100 rounded-full text-[9px] font-black text-slate-500 uppercase tracking-widest">Identity</div>
            </div>
            <div>
              <h2 className="text-slate-900 font-black text-sm sm:text-base tracking-tight">Identity Management</h2>
              <p className="text-slate-400 text-[10px] font-bold leading-tight mt-1">Download and manage credentials</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReporterDashboard;
